import { useMemo } from "react"
import { useAuth } from "@/features/auth/AuthContext"
import {
  mergeSubtreeModeratorAdminAccess,
  type AssociationsModerationNavGate,
} from "@/features/associations/associationsModerationNavGate"
import { useAssociationsModerationNavGate } from "@/features/associations/useAssociationsModerationNavGate"
import { useAdminAccess, type AdminAccess } from "@/features/admin/useAdminAccess"

export type EffectiveAdminAccess = AdminAccess & {
  associationsModerationGate: AssociationsModerationNavGate
  /** false — пока не завершена проверка модератора поддерева союза (для навигации и guard). */
  adminAccessResolved: boolean
}

export const useEffectiveAdminAccess = (): EffectiveAdminAccess => {
  const { accessToken, setSession, grantedPolicies } = useAuth()
  const baseAccess = useAdminAccess()
  const associationsModerationGate = useAssociationsModerationNavGate({
    accessToken,
    setSession,
    grantedPolicies,
    baseAccess,
  })

  return useMemo(() => {
    const merged = mergeSubtreeModeratorAdminAccess(baseAccess, associationsModerationGate)
    return {
      ...merged,
      associationsModerationGate,
      adminAccessResolved: associationsModerationGate.ready,
    }
  }, [associationsModerationGate, baseAccess])
}
